import * as React from 'react';
import {MoneyFormatDisplayMode, MoneyFormatProps} from './types';

export default class MoneyFormat extends React.Component<MoneyFormatProps> {
  public render() {
    const {
      currency,
      amount,
      displayMode = MoneyFormatDisplayMode.SYMBOL
    } = this.props;
    const isVnd = currency.toUpperCase() === 'VND';

    return (
      <React.Fragment>
        {amount.toLocaleString(undefined, {
          style: 'currency',
          currency,
          currencyDisplay: displayMode,
          ...(isVnd && {maximumSignificantDigits: 3})
        })}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MoneyFormat/MoneyFormat.tsx